import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

const Section: React.FC<SectionProps> = ({ children, className = '', id = '' }) => (
  <section id={id} className={`py-20 lg:py-28 px-4 sm:px-6 lg:px-8 relative ${className}`}>
    <div className="max-w-7xl mx-auto">
      {children}
    </div>
  </section>
);

export default Section;
